export const USER_CREATE_EMPLOYEE_SUCCESS = 'BID_EMPLOYEE_CREATE_EMPLOYEE'